module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salary-rules__rule-container"
  }, [(_vm.rules.length === 0) ? _c('h4', {
    staticClass: "text-explainer",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("Ingen regler oprettet")]) : _vm._e(), _vm._v(" "), _c('draggable', {
    staticClass: "salary-rules__rule-container__draggable",
    on: {
      "change": _vm.onChangeOrder
    },
    model: {
      value: (_vm.rules),
      callback: function($$v) {
        _vm.rules = $$v
      },
      expression: "rules"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": "flip-list",
      "tag": "ul"
    }
  }, _vm._l((_vm.rules), function(rule, key) {
    return _c('li', {
      key: rule.id,
      staticClass: "salary-rules__rule"
    }, [_c('div', [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('div', [_vm._v("\n          Hvis\n        ")]), _vm._v(" "), _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.type),
        expression: "rule.type"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(rule, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.onChangeRuleType(rule, $event.target.value)
        }]
      }
    }, _vm._l((_vm.ruleTypes), function(ruleType) {
      return _c('option', {
        domProps: {
          "value": ruleType.value
        }
      }, [_vm._v("\n              " + _vm._s(ruleType.title) + "\n            ")])
    }), 0)]), _vm._v(" "), (rule.type === 'employment_type') ? _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.substituted_employment_title),
        expression: "rule.substituted_employment_title"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(rule, "substituted_employment_title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.onChange]
      }
    }, _vm._l((_vm.employmentsTypesForFullTime), function(employmentsType) {
      return _c('option', {
        domProps: {
          "value": employmentsType
        }
      }, [_vm._v("\n              " + _vm._s(employmentsType) + "\n            ")])
    }), 0)]) : _vm._e(), _vm._v(" "), (rule.type === 'subject_type') ? _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.subject_type),
        expression: "rule.subject_type"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(rule, "subject_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.onChange]
      }
    }, _vm._l((_vm.subjectTypes), function(subjectType) {
      return _c('option', {
        domProps: {
          "value": subjectType.value
        }
      }, [_vm._v("\n              " + _vm._s(subjectType.name) + "\n            ")])
    }), 0)]) : _vm._e(), _vm._v(" "), (rule.type === 'subject_title') ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (rule.subject_title),
        expression: "rule.subject_title",
        modifiers: {
          "trim": true
        }
      }],
      ref: 'subjectTitleInput' + rule.id,
      refInFor: true,
      staticClass: "rule-input-text",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (rule.subject_title)
      },
      on: {
        "keyup": _vm.onChange,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(rule, "subject_title", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]) : _vm._e(), _vm._v(" "), (rule.type === 'calendar_id') ? _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.calendar_id),
        expression: "rule.calendar_id"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(rule, "calendar_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.onChange]
      }
    }, _vm._l((_vm.calendars), function(calendar) {
      return _c('option', {
        domProps: {
          "value": calendar.id
        }
      }, [_vm._v("\n              " + _vm._s(calendar.name) + "\n            ")])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("skal det tælle som")]), _vm._v(" "), _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.selected_employment_title),
        expression: "rule.selected_employment_title"
      }],
      staticClass: "do-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(rule, "selected_employment_title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.onChange]
      }
    }, _vm._l((_vm.employmentToSelectForRules), function(employmentsType) {
      return _c('option', {
        domProps: {
          "value": employmentsType
        }
      }, [_vm._v("\n              " + _vm._s(employmentsType) + "\n            ")])
    }), 0)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'left'
        }),
        expression: "{\n                  arrow: true,\n                  placement : 'left'\n                }"
      }],
      staticClass: "icon__bg-circle d-item-delete icon__bg-circle--danger",
      attrs: {
        "content": _vm.$t('vue2.common.delete')
      },
      on: {
        "click": function($event) {
          return _vm.setRoleToDelete(rule)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })])])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "do-buttons"
  }, [_c('button', {
    staticClass: "btn-trans",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addNewRule.apply(null, arguments)
      }
    }
  }, [_vm._v("+ Tiløj regel")]), _vm._v(" "), (_vm.isChangeHasBeenMade) ? _c('div', {
    staticClass: "do-submit-buttons"
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSaving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c0615e10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettingsRules/SalaryRule1.vue
// module id = 1809
// module chunks = 1